import React from 'react'
import { Route } from 'react-router-dom'
import { useAuthState } from 'react-firebase-hooks/auth'
import { useTranslation } from 'react-i18next'
import { auth } from '@BUP/configs/Firebase'
import BupLoading from '@BUP/components/Loading/Main'

export default function AuthenticatedRoute ({ component: Component, ...rest }) {
  const [user, loading, error] = useAuthState(auth)
  const i18n = useTranslation()

  if (loading) return <BupLoading />
  if (error) return <p>{i18n.t('common.resources.user.actions.read.failure', { context: 'with-message', message: error.message })}</p>
  if (!user) return <p>{i18n.t('common.resources.user.actions.read.failure', { context: 'no-user' })}</p>

  return (
    <Route
      {...rest}
      render={props => <Component {...props} />}
    />
  )
}
